import { UsersTable, UserFilterType } from "../../components/users/UsersListTable.component";
import { AddUsersButton } from "../../components/users/AddNewButton.component";
import { ExportUserListButton } from "../../components/users/ExportUserListBtn.component";
import { ImportUserListButton } from "../../components/users/ImportUserListBtn.component";
import { ExportTemplateButton } from "../../components/users/ExportTemplateBtn.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { useState } from 'react';
import { SearchInputField } from "../../components/generic/searchInputField.component";
import { SelectPicker } from "rsuite";
const filterOptions = [
  { label: "All Users", value: "all" },
  { label: "Subscribed Paid Users", value: "paid" },
  { label: "Regbrief Subscribed Users", value: "regbrief" },
  { label: "Trial Users", value: "trial" },
];

export const UsersListPage = () => {
  const [searchKey, setSearchKey] = useState<string>("");
  const [filterType, setFilterType] = useState<UserFilterType>("all");
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header">
            Users <BreadCrumbSign /> List
          </p>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <AddUsersButton />
            <div className="d-flex justify-content-between align-content-center">
              <ExportTemplateButton />
              <ImportUserListButton />
              <ExportUserListButton filterType={filterType} />
              <SelectPicker
                data={filterOptions}
                value={filterType}
                onChange={(value) => setFilterType((value as UserFilterType) || "all")}
                cleanable={false}
                searchable={false}
                className="user-filter-dropdown me-2"
                placeholder="Filter Users"
              />
              <SearchInputField
                searchKey={searchKey}
                setSearchKey={setSearchKey}
              />
            </div>
          </div>
          <UsersTable searchKey={searchKey} filterType={filterType}/>
        </div>
      </div>
    </div>
  );
};
